import script from "./Tickets.vue?vue&type=script&setup=true&lang=js"
export * from "./Tickets.vue?vue&type=script&setup=true&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=3f74d865&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f74d865"]])

export default __exports__